import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import {
  FlexCenterWrapper, WhiteSpaceNoWrap, Mr3, CustomBackgroundWrapper, CustomHeight, My2,
  FitRelativeWrapper, AbsoluteLeftTopWrapper, Mx2, FlexCenterJustifyCenterWrapper, Mb7,
  CustomBorderWrapper, CursorPointerWrapper, Mr2, OpacityWrapper, FullWidthFlexboxCentered
} from 'wrappers';
import { Count } from 'molecules';
import internalState from './internalState';
import {
  Icon, SecondaryTextSm, SecondaryTextSmBold, WhiteTextSm,
  ClickableIcon, PrimaryTextBaseBold
} from 'atoms';
import { LeftArrowSvg, RightArrowSvg, DownCaretSvg } from 'components/icons';
import { DayText } from '../recurrenceDatePicker/atoms';
import { getOrdinalSuffix, months } from 'utils';

const weekdays = [
  {
    shortName: 'S',
    longName: 'Sunday',
    id: 'sunday'
  },
  {
    shortName: 'M',
    longName: 'Monday',
    id: 'monday'
  },
  {
    shortName: 'T',
    longName: 'Tuesday',
    id: 'tuesday'
  },
  {
    shortName: 'W',
    longName: 'Wednesday',
    id: 'wednesday'
  },
  {
    shortName: 'T',
    longName: 'Thursday',
    id: 'thursday'
  },
  {
    shortName: 'F',
    longName: 'Friday',
    id: 'friday'
  },
  {
    shortName: 'S',
    longName: 'Saturday',
    id: 'saturday'
  },
]

export const definition = {
  name: 'RecurrenceSubscriptionDropdown',
  controller: Controller,
  initialProps: ({ label, isReadonly, placeholder, width, occurrenceValues, frequency }) => ({ label, isReadonly, placeholder, width, occurrenceValues, frequency }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: OpacityWrapper,
          name: '__transparent__',
          renderIf: ({ isReadonly }) => isReadonly,
          displayState: ({ }) => ({ opacity: '.5' }),
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'Header',
              elements: [
                {
                  component: wrap(wrap(wrap(SecondaryTextSmBold, WhiteSpaceNoWrap), Mr3), My2),
                  displayValue: ({ label }) => label
                },
                {
                  component: wrap(SecondaryTextSm, Mr2),
                  name: 'Button',
                  renderIf: ({ occurrenceValues }) => occurrenceValues.length > 0,
                  displayValue: ({ occurrenceValues, frequency }) => {
                    if (frequency === 'weekly') {
                      return occurrenceValues.slice(0, 3).map(o => weekdays.find(w => w.id === o).longName).join(', ')
                    } else {
                      return occurrenceValues.slice(0, 3).join(', ')
                    }
                  },
                },
                {
                  component: wrap(SecondaryTextSm, Mr2),
                  name: 'Button',
                  renderIf: ({ occurrenceValues, placeholder }) => placeholder && occurrenceValues.length === 0,
                  displayValue: ({ placeholder }) => placeholder
                },
                {
                  component: wrap(Count, Mr2),
                  renderIf: ({ occurrenceValues }) => occurrenceValues.length > 3,
                  name: 'Count',
                  bindings: ({ occurrenceValues }) => ({ count: occurrenceValues.length - 3 })
                },
                {
                  component: Icon,
                  name: 'Caret',
                  displayValue: ({ }) => DownCaretSvg({ color: '#C2CCCE' })
                },
              ]
            },
          ]
        },
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'Header',
          renderIf: ({ isReadonly }) => !isReadonly,
          isButton: true,
          bindings: ({ isOpen, occurrenceValues, containerRef }) => ({ isOpen, containerRef, occurrenceValues }),
          elements: [
            {
              component: wrap(wrap(wrap(SecondaryTextSmBold, WhiteSpaceNoWrap), Mr3), My2),
              displayValue: ({ label }) => label
            },
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'Button',
              renderIf: ({ occurrenceValues }) => occurrenceValues.length > 0,
              displayValue: ({ occurrenceValues, frequency }) => {
                if (frequency === 'weekly') {
                  return occurrenceValues.slice(0, 3).map(o => weekdays.find(w => w.id === o).longName).join(', ')
                } else if (frequency === 'annually') {
                  return occurrenceValues.slice(0, 3).map(o => `${months.find(m => m.index == o.split('/')[0]).name} ${getOrdinalSuffix(o.split('/')[1])}`).join(', ')
                } else {
                  return occurrenceValues.slice(0, 3).join(', ')
                }
              },
            },
            {
              component: wrap(SecondaryTextSm, Mr2),
              name: 'Button',
              renderIf: ({ occurrenceValues, placeholder }) => placeholder && occurrenceValues.length === 0,
              displayValue: ({ placeholder }) => placeholder
            },
            {
              component: wrap(Count, Mr2),
              renderIf: ({ occurrenceValues }) => occurrenceValues.length > 3,
              name: 'Count',
              bindings: ({ occurrenceValues }) => ({ count: occurrenceValues.length - 3 })
            },
            {
              component: Icon,
              name: 'Caret',
              displayValue: ({ }) => DownCaretSvg({ color: '#C2CCCE' })
            },
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '24px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({ borderRadius: '20px', border: '1px solid #E3E3E3', background: '#FFFFFF', padding: '20px' }),
              elements: [
                {
                  wrapper: FlexCenterWrapper,
                  name: 'Weekdays',
                  renderIf: ({ frequency }) => frequency === 'weekly',
                  elements: [
                    {
                      wrapper: Mx2,
                      name: '__transparent__',
                      isListOf: { day: ({ }) => weekdays },
                      elements: [
                        {
                          wrapper: CustomBackgroundWrapper,
                          name: 'Day',
                          isButton: true,
                          bindings: ({ day, occurrenceValues }) => ({ day, occurrenceValues }),
                          displayState: ({ day, occurrenceValues }) => ({
                            borderRadius: '50%', width: '26px', height: '26px', background: occurrenceValues?.includes(day.id) ? window?.settings?.primary_color : '#F3F5F5', alignItems: 'center', justifyContent: 'center', cursor: 'pointer'
                          }),
                          elements: [
                            {
                              component: SecondaryTextSm,
                              name: 'Day',
                              renderIf: ({ occurrenceValues, day }) => !occurrenceValues?.includes(day.id),
                              displayValue: ({ day }) => day.shortName,
                            },
                            {
                              component: WhiteTextSm,
                              name: 'Day',
                              renderIf: ({ occurrenceValues, day }) => occurrenceValues?.includes(day.id),
                              displayValue: ({ day }) => day.shortName,
                            }
                          ]
                        }
                      ]
                    },
                  ]
                },
                {
                  wrapper: wrap(FlexCenterJustifyCenterWrapper, Mb7),
                  name: 'CalendarHeader',
                  renderIf: ({ frequency }) => frequency === 'annually',
                  elements: [
                    {
                      component: wrap(ClickableIcon, Mx2),
                      name: 'PrevMonth',
                      bindings: ({ selectedMonthIndex }) => ({ selectedMonthIndex }),
                      displayValue: ({ }) => LeftArrowSvg({})
                    },
                    {
                      component: PrimaryTextBaseBold,
                      name: 'MonthName',
                      displayValue: ({ selectedMonthIndex }) => months.find(month => month.index === selectedMonthIndex).name,
                    },
                    {
                      component: wrap(ClickableIcon, Mx2),
                      name: 'NextMonth',
                      bindings: ({ selectedMonthIndex }) => ({ selectedMonthIndex }),
                      displayValue: ({ }) => RightArrowSvg({})
                    },
                  ]
                },
                {
                  wrapper: CustomHeight,
                  displayState: ({ }) => ({ width: '256px' }),
                  name: '__transparent__',
                  elements: [
                    {
                      wrapper: FullWidthFlexboxCentered,
                      name: 'Dates',
                      renderIf: ({ frequency }) => ['monthly', 'annually'].includes(frequency),
                      elements: [
                        {
                          component: DayText,
                          name: 'Day',
                          isListOf: 'dates',
                          displayValue: ({ date }) => date.toString(),
                          displayState: ({ date, occurrenceValues, selectedMonthIndex, frequency }) => ({ selected: frequency === 'annually' ? occurrenceValues.includes(`${selectedMonthIndex}/${date}`) : occurrenceValues.includes(date.toString()) }),
                          bindings: ({ date, occurrenceValues, frequency, selectedMonthIndex }) => ({ date, occurrenceValues, frequency, selectedMonthIndex })
                        }
                      ]
                    }
                  ]
                },
              ]
            }
          ]
        }

      ]
    }
  ]
};

export default ContainerComponent(definition)